import React from 'react';
import { useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core';
import { backgroundImageSelector } from '../../store/selectors/globalConfigSelectors';
import { appErrorSelector, loaderSelector } from '../../store/selectors/appSelectors';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import MainContentWrapper from '../../components/ContentWrapper/MainContentWrapper';
import PageLoader from '../../components/PageLoader';
import AppError from '../../components/AppError/AppError';
const useStyles = (backgroundImage) =>
  makeStyles((theme) => ({
    root: {
      display: 'flex',
      height: '100vh',
      flexDirection: 'column',
      position: 'relative',
      overflowY: 'auto',
      zIndex: '999',
      background: `url(${backgroundImage}) no-repeat fixed`,
      backgroundPosition: 'center',
      backgroundSize: 'cover',
      // scrollbarColor: `${theme.palette.primary.main} transparent`,
      // scrollbarWidth: 'thin',
    },
  }));

const DefaultMainTemplate = ({ children }) => {
  const backgroundImage = useSelector(backgroundImageSelector);
  const classes = useStyles(backgroundImage)();
  const appError = useSelector(appErrorSelector);
  const showLoader = useSelector(loaderSelector);

  return (
    <main className={classes.root}>
      <Header />

      <MainContentWrapper>{appError ? <AppError /> : children}</MainContentWrapper>
      {showLoader && <PageLoader />}
      <Footer />
    </main>
  );
};

export default DefaultMainTemplate;
